import {
  take,
  call,
  put,
  fork,
  all,
  takeEvery
} from 'redux-saga/effects'

import {
  UNMOUNT,
  MOUNT,
} from './constants'
import {
  POST_WORKFLOW_SUBMIT_SUCCESS,
  POST_WORKFLOW_SUBMIT_ERROR,
} from 'containers/Project/constants'
import {
  clearRedirect,
  updateRedirect
} from './actions'

function* watchSubmitProject() {
  while(true) {
    const action = yield take([
      POST_WORKFLOW_SUBMIT_SUCCESS,
      POST_WORKFLOW_SUBMIT_ERROR
    ])

    if (action.type === POST_WORKFLOW_SUBMIT_SUCCESS) {
      yield put(updateRedirect(true))
    }
  }
}

function* reset() {
  yield put(clearRedirect())
}

function* handleMount() {
  yield call(reset)
}

function* handleUnmount() {
  yield call(reset)
}

function* watchMount() {
  yield takeEvery(MOUNT, handleMount)
}

function* watchUnmount() {
  yield takeEvery(UNMOUNT, handleUnmount)
}

function* loadSagas() {
  yield all([
    fork(watchMount),
    fork(watchUnmount)
  ])
}

export {
  watchSubmitProject
}
export default loadSagas
